import { render } from "./loginPgae.vue?vue&type=template&id=6832c9b3"
import script from "./loginPgae.vue?vue&type=script&lang=js"
export * from "./loginPgae.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__